import styled from 'styled-components';
import Layout from 'antd/es/layout/layout';

import { EXTRA_LARGE_VIEWPORT, MEDIUM_VIEWPORT, MOBILE_VIEWPORT, SMALL_VIEWPORT } from 'modules/theme/config';

export const StyledLayout = styled(Layout)`
  &.ant-layout {
    display: flex;
    margin-top: 32px;
    flex-direction: row;

    @media (max-width: ${MEDIUM_VIEWPORT}px) {
      margin-top: 24px;
    }

    @media (max-width: ${MOBILE_VIEWPORT}px) {
      margin-top: 12px;
    }
  }
`;

export const FirstColumnContainer = styled.div`
  min-width: 436px;
  padding-right: 32px;
  display: flex;
  flex-direction: column;
  position: relative;

  @media (max-width: ${EXTRA_LARGE_VIEWPORT}px) {
    min-width: 264px;
  }
`;

export const SecondColumnContainer = styled.div`
  flex: 1;
  width: 572px;
  min-height: calc(100vh - 296px);
  gap: 16px;
  flex-direction: column;
  display: flex;

  @media (max-width: ${SMALL_VIEWPORT}px) {
    flex: 1;
    width: 100%;
    min-height: auto;
  }
`;
